module.exports = __webpack_public_path__ + "static/shadow_arrow.c761ab9e6f5252fb0d64e51cde47ca88.png";